<template>
  <div>
    <div class="d-flex align-center">
      <v-text-field
        label="Recherchez par numero de reconnaissance"
        append-icon="mdi-magnify"
        v-model="numeroReconnaissance"
        outlined
        :disabled="updating"
        :loading="updating"
        @click:append="search"
        @keydown.enter="search"
        style="max-width: 400px"
        autocomplete="nope"
      ></v-text-field>
    </div>
    <v-alert text border="left" type="info" v-show="this.errorMessage">{{ this.errorMessage }}</v-alert>

    <v-dialog v-model="dialog" width="700">
      <v-card class="pa-6">
        <h2 class="headline mb-3">Résultats</h2>
        <p>Cliquez sur votre activité dans l'encadré ci-dessous pour continuer votre déclaration.</p>
        <v-card
          v-for="formation in result"
          :key="formation.id"
          @click="formationSelected(formation)"
          class="pa-6 mb-3"
          outlined
          max-width="450"
        >
          <h3>{{ formation.numeroReconnaissance }}</h3>
          <p class="mb-0 caption">{{ formation.titre }}</p>
        </v-card>
        <div class="text-center mt-6">
          <v-btn color="primary" @click="dialog = false">Annuler</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { findByNumeroReconnaissance } from "@/plugins/services/formationsReconnues"
import CataloguesHelper from "@/mixins/CataloguesHelpers"
export default {
  mixins: [CataloguesHelper],
  data() {
    return {
      numeroReconnaissance: "",
      updating: false,
      result: [],
      errorMessage: "",
      dialog: false
    }
  },
  methods: {
    search() {
      this.result = []
      this.updating = true
      findByNumeroReconnaissance(this.numeroReconnaissance)
        .then((res) => {
          this.result = res.data
          if (this.result.length == 0) {
            this.errorMessage = "Aucune formation trouvée, essayez un autre numero de reconnaissance."
          } else {
            this.dialog = true
            this.errorMessage = ""
          }
        })
        .catch((err) => {
          this.result = []
          this.errorMessage = err.response.data.message
        })
        .finally(() => {
          this.updating = false
        })
    },
    formationSelected(formation) {
      this.$emit("formation-selected", formation)
      this.numeroReconnaissance = formation.numeroReconnaissance
      this.dialog = false
    }
  }
}
</script>

<style>
</style>